import { FeatureFlag, useFeatureFlag } from '~/lib/flags';
import { useSessionStore } from '~/stores/Session';

import { SSO_MANAGEMENT_ROLES } from './constants';

export const useCanManageSSO = (): boolean => {
  const enabled = useFeatureFlag(FeatureFlag.EnableDashboardSSO);
  const roleName = useSessionStore((state) => state.platformRole?.name);
  return enabled && !!roleName && SSO_MANAGEMENT_ROLES.includes(roleName);
};
